<template>
  <div>
    <van-popup v-model="show" class="popup_red" duration="0.05" @close="close">
      <!-- 获取学管师发送的红包碎片 -->
      <div class="zjs__advert">
        <div v-if="!getSuccess">
          <div class="title">{{ showItem.guideName }}送你{{ showItem.sentNumber }}个碎片</div>
          <div class="contant">
            <img
              class="bg"
              src="https://img.yzcdn.cn/upload_files/2020/07/20/FsMEgs0eYZByHOGyHa5qomiZxr75.png"
            />
            <div class="num">
              <img
                src="https://img.yzcdn.cn/upload_files/2020/07/20/FjQlCVBN-ov7_CgNmWgQrZuCj6fK.png"
              />
              <div class="number"><span>X</span>{{ showItem.sentNumber }}</div>
            </div>
            <div class="reason">
              <span>赠送理由：{{ showItem.sentReason }}</span>
            </div>
            <div class="take" @click="take(showItem.id)">
              <img
                src="https://img.yzcdn.cn/upload_files/2020/07/20/FmRbQb-EUXpGZWGe3hplUa42L4eC.png"
              />
            </div>
          </div>
          <div @click.stop>
            <img
              class="close"
              src="https://img.yzcdn.cn/upload_files/2019/11/25/Fs53hUSGrw074xduGjRxvDIQSTYd.png"
              
              @click.stop="show = false"
            />
          </div>
        </div>
        <div v-if="getSuccess" class="success-alert">
          <img
            src="https://img.yzcdn.cn/upload_files/2020/07/21/FphFrFdZ2qZoe4CdTGh9cDkNBK35.png"
          />
          <div class="middle">
            恭喜您成功领取<span>{{ oldItem.sentNumber }}个</span>碎片
          </div>
          <img
            class="btn"
            src="https://img.yzcdn.cn/upload_files/2020/07/21/Fpr45egoYIzg9mhId7F5b6wlXcWE.png"
            @click="showGetAlet()"
          />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { register } from '@/plugin/popup'
import { getformData } from '@/static/js/zjs.js'
export default {
  data() {
    return {
      show: false,
      getSuccess: false,
      showItem: {},
      allItem: [],
      userInfo: {},
      url: ''
    }
  },
  computed: {
  },
  watch: {
    '$route': {
      handler: function(val) {
        this.url = val
      },
      immediate: true
    }
  },

  mounted() {
    register({
      name: 'XueRed',
      open: ({ afterClose, allItem }) => {
        this.afterClose = afterClose
        this.show = true
        this.allItem = allItem
        this.showItem = allItem[0]
      },
      close: () => {
        this.close()
      }
    })
  },
  methods: {
    close() {
      this.show = false
      if (this.afterClose) {
        this.afterClose()
      }
    },
    // 确定
    showGetAlet() {
      if (this.allItem.length === 0) {
        this.close()
      } else {
        this.getSuccess = false
      }

      this.getPieces()
      this.getscholarship()
    },
    // 获取红包碎片
    take(id) {
      this.$http
        .post(
          '/cms/redenvelope/receive',
          getformData({
            openid: this.$store.openid,
            id: id
          })
        )
        .then((res) => {
          this.getSuccess = true
          this.oldItem = this.showItem
          this.allItem = this.allItem.filter((item) => item.id !== id)
          this.showItem = this.allItem[0]
          this.getPieces()
        })
    },
    getPieces() {
      this.$http.get(`/cms/redenvelope/getred?openid=${this.$store.openid}`).then((res) => {

        if (res.data) {
          this.$store.commit('user/setRedNum', res.data.fragmentNum)
        }
      })
    },
    getscholarship() {
      this.$http
        .get(`/cms/redenvelope/getscholarship?openid=${this.$store.openid}`)
        .then((res) => {

          if (res.data) {
            this.$store.commit('user/setRedMoney', res.data.money || 0)
          }
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.zjs__advert {
  position: relative;
  width: 7.49rem;
  animation: change 0.3s ease;
}
@keyframes change {
  0% {
    transform: scale(0);
  }
  25% {
    transform: scale(0.25);
  }
  50% {
    transform: scale(0.5);
  }
  75% {
    transform: scale(0.75);
  }
  100% {
    transform: scale(1);
  }
}
.popup_red.van-popup {
  background-color: transparent;
  .bg {
    width: 100%;
  }
  .contant {
    position: relative;
  }
  .title {
    position: absolute;
    top: 2.85rem;
    font-size: 0.43rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    z-index: 9;
    width: 100%;
    text-align: center;
  }
  .num {
    position: absolute;
    top: 4.25rem;
    left: 50%;
    display: flex;
    align-items: center;
    transform: translateX(-50%);
    img {
      width: 1.23rem;
    }
    .number {
      margin-left: 0.29rem;
      font-size: 1.07rem;
      font-weight: 500;
      color: rgba(253, 177, 32, 1);
      line-height: 1;
      span {
        font-size: 0.75rem;
        font-weight: 500;
        color: rgba(253, 177, 32, 1);
        margin-right: 0.15rem;
      }
    }
  }
  .reason {
    position: absolute;
    bottom: 2.05rem;
    left: 50%;
    transform: translateX(-50%);
    width: 5.43rem;
    font-size: 0.32rem;
    color: rgba(171, 151, 106, 1);
    display: flex;
    align-items: center;
    height: 1.15rem;
    span {
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }
  .take {
    width: 5.41rem;
    position: absolute;
    bottom: 0.4rem;
    left: 50%;
    transform: translateX(-50%);
    img {
      width: 100%;
    }
  }
}
.close {
  width: 0.75rem;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  padding-top: 0.53rem;
}

.popup_red .van-popup__close-icon--top-right {
  display: none;
  position: absolute;
  top: 2.96rem;
  right: 0.44rem;
  font-size: 0.4rem;
}
.success-alert {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  animation: change 0.3s ease;
  img {
    width: 6.96rem;
  }
  .middle {
    font-size: 0.48rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    margin-top: 0.72rem;
    line-height: 1;
    span {
      color: #fdb220;
    }
  }
  .btn {
    width: 5.41rem;
    margin-top: 1.39rem;
  }
}
</style>
